import {url} from "../utilities";
import {toastAlert} from "../toastAlert";
import {confirmModal} from "../confirmModal";
import axios from "axios";
import * as $ from "jquery";
import {EpMap} from "../map/map";
import {Collection, Feature} from "ol";
import {Point} from "ol/geom";
import {fromLonLat, toLonLat} from "ol/proj";
import {getArea, getLength} from 'ol/sphere';
import {EpHeatmap} from "../map/layers/heatmap";
import {EpLayer} from "../map/layers/layer";
import _ from 'lodash';
import {
    drawInventoryLocationStyle,
    farInventoryLocationStyle, inventoryLocationBeatersLineStyle, inventoryLocationObserversLineStyle,
    inventoryLocationStyle
} from "../map/styles/inventory-locations";
import * as turf from '@turf/turf';
import buffer from '@turf/buffer';
import {LayerControl} from "../map/layers/LayerControl";
import {createFeatureFromCoordinates} from "../map/utilities";
import Spinner from "../spinner";
import {EpInventoryObservations} from "../map/layers/inventory-observations";
import FileDownload from "js-file-download";

export const inventories_page = () => {

    const body = $('body');

    /// Tables
    const locationsTable = $('#locationsTable').DataTable();
    const templatesTable = $('#inventoryTemplatesTable');

    templatesTable.DataTable({
        responsive: {
            details: {
                display: $.fn.dataTable.Responsive.display.childRow,
                type: 'inline'
            }
        },
    })

    // Clone inventory handlers
    $('[data-bs-target="#cloneInventoryModal"]').click(function() {
        let id = $(this).data('id');

        const form = $('#cloneInventoryModal').find('form')

        form.attr('action', window._INVENTORY_CLONE_URL.replace('REPLACE_ID', id));
    })

    body.on('click', '.btnDeleteLocation', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć ten obszar?', {color: 'danger'});
        if (!confirm) return;

        try {
            const response = await axios.post(url(`api/inventories/locations/${$(this).data('id')}/delete`));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let row = locationsTable.$(`tr[data-id=${$(this).data('id')}]`)
            locationsTable.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto obszar');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia obszaru', {type: 'danger'})
        }
    })

    $("#editInventory select[name='inventory_type_id']").change(function() {
        let id = $(this).val();
        let modal = $('#typeDescriptionModal');

        if(modal.length > 0) {
            modal.find('.type-description').hide();
            modal.find('.type-description[data-id="'+id+'"]').show();
        }

        let videoId = window._tutorials[$(this).val()];
        $('.btnVideotutorial').attr('href', `https://www.youtube.com/watch?v=${videoId}`)
    }).change();

    $("[name='area']").on('input', function() {
        $(this).closest('.col-12').find('[name="area_changed_manually"]').val(1);

        if($(this).val().length === 0) {
            $(this).closest('.col-12').find('[name="area_changed_manually"]').val(0);
        }
    })

    $('form#addUser select[name="type_id"]').change(function() {
        let elements = $(this)
            .closest('form')
            .find('[name="first_name"], [name="last_name"], [name="email"], [name="phone_number"], [name="address_line_1"], [name="address_line_2"], [name="postal_code"],[name="city"]')
            .closest('.input-group')
            .parent()
            .closest('div');

        if(parseInt($(this).val()) === 7) {
            elements.hide();
        } else {
            elements.show();
        }
    }).trigger('change');

    const calculateAreas = () => {
        const areaPercentage = $('.area-percentage');
        const areaDistrict = $('.area-district');

        if(areaPercentage.length > 0) {
            let districtArea = parseFloat(areaDistrict.text());
            let inventoryArea = parseFloat($('.area-inventory').text());

            if(districtArea === 0 && window._boundaries.length > 0) {
                try {
                    districtArea = getArea(createFeatureFromCoordinates(window._boundaries).getGeometry()) / 10000;
                    areaDistrict.text(districtArea.toFixed(2))
                } catch(err) {}
            }

            if(inventoryArea === 0) {
                areaPercentage.text('Nie wprowadzono obszaru inwentaryzacji');
                return;
            }

            if(districtArea === 0) {
                areaPercentage.text('Nie wprowadzono granic obwodu');
                return;
            }

            let percentage = (inventoryArea / districtArea) * 100;
            areaPercentage.text(percentage.toFixed(2) + '%');
        }
    }
    calculateAreas();

    // Map
    let mapContainer = $("#map");
    if (mapContainer.length > 0) {
        const changeMapSize = () => {
            let height = 400;
            mapContainer.height(height - 32);
        }
        changeMapSize();

        let epMap = new EpMap({target: 'map', hideLabelsIfNecessary: true, fitSectorsAndBoundariesAfterInit: false});
        epMap.addSectorsLayer();

        if(typeof window._locations != 'undefined') {
            let locations = JSON.parse(window._locations);

            // locations layer
            let locationsLayer = new EpLayer(epMap.map);
            locationsLayer.setStyle(inventoryLocationStyle, farInventoryLocationStyle);
            locationsLayer.name = 'locations';
            locationsLayer.title = 'Obszary';

            epMap.changeStyleUnderZoom(locationsLayer)

            for(let location of locations) {
                locationsLayer.addFeature(location.coordinates, {
                    fields: {
                        name: location.name
                    }
                });
            }

            epMap.addCustomLayer(locationsLayer);
            locationsLayer.fitInView();
        }

        epMap.addBoundariesLayer();

        // enable bdl
        if(typeof LayerControl.getLayerSavedVisibility('bdl-0') == 'undefined') {
            LayerControl.setLayerSavedVisibility('bdl-0', true)
        }

        if(typeof LayerControl.getLayerSavedVisibility('bdl-1') == 'undefined') {
            LayerControl.setLayerSavedVisibility('bdl-1', true)
        }

        if(typeof window._boundaries != 'undefined') {
            epMap.boundaries.addFeature(window._boundaries);
            epMap.boundaries.fitInView();
        }

        if(typeof window._sectors != 'undefined') {
            epMap.sectors.addSectorsFromObject(JSON.parse(window._sectors));
        }

        if(typeof window._true_heatmap_data != 'undefined') {
            let trueHeatmapData = JSON.parse(window._true_heatmap_data);

            // true heatmap layer
            let trueHeatmapLayer = new EpHeatmap(epMap.map);
            trueHeatmapLayer.name = 'true_heatmap';
            trueHeatmapLayer.title = 'Mapa cieplna zwierzyny';
            trueHeatmapLayer.defaultVisibility = false;

            for(let data of trueHeatmapData) {
                let feature = new Feature({
                    geometry: new Point(fromLonLat([data.longitude, data.latitude])),
                    weight: data.weight
                });
                trueHeatmapLayer.getSource().addFeature(feature);
            }

            epMap.addCustomLayer(trueHeatmapLayer);
        }

        let observations = typeof window._observations == 'undefined' ? [] : JSON.parse(window._observations);
        if(observations.length > 0) {
            let layer = new EpInventoryObservations();

            let table = $('#observedItemsTable');
            if(table.length > 0) {
                table = table.DataTable().api();

                table.$('tr').click(function() {
                    let number = $(this).data('number')

                    layer.getSource().getFeatures().forEach(function(feature) {
                        if(feature.get('number') === number) {
                            let extent = feature.getGeometry().getExtent();
                            map.getView().fit(extent, {maxZoom: 17})
                        }
                    })
                })
            } else {
                table = null;
            }

            epMap.addCustomLayer(layer)
            epMap.changeStyleUnderZoom(layer, 10)

            let map = epMap.getOlMap();

            map.on("click", function(e) {
                if(table) {
                    table.search('');
                }

                layer.getSource().getFeatures().forEach(feature => feature.set('selected', false))

                map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
                    if(layer.get('name') === 'observations') {
                        feature.set('selected', true);

                        if(table) {
                            table.search('obserwacja:' + feature.get('data').number);
                        }
                    }
                })

                if(table) {
                    table.draw();
                }
            });

            for(let observation of observations) {
                if(!observation.longitude || !observation.latitude) continue;

                layer.addObservation(observation);
            }

            epMap.setupTooltips('tooltip', ['observation'])
        }
    }

    // Inventory locations
    let inventoryLocationsMapContainer = $('.inventory-locations-map');
    if(inventoryLocationsMapContainer.length > 0) {
        inventoryLocationsMapContainer.height($(document).height() - 300);
        const target = inventoryLocationsMapContainer.attr('id');

        // Prevent from submitting with "enter" keyboard
        $(window).keydown(function(event){
            if(event.keyCode === 13) {
                event.preventDefault();
                return false;
            }
        });

        const setupLocationInteractions = () => {
            let mode = 0;

            const form = $('body').find('form');

            const coordinatesInput = form.find('[name="coordinates"]')
            const observersLineCoordinatesInput = form.find('[name="observers_line_coordinates"]')
            const beatersLineCoordinatesInput = form.find('[name="beaters_line_coordinates"]')

            const areaInput = form.find('[name="area"]')
            const areaChangedManually = form.find('[name="area_changed_manually"]')

            const btnDrawLocation = $("#btnDrawLocation");
            const btnDeleteLocation = $("#btnDeleteLocation");
            const btnDrawObserversLine = $('#btnDrawObserversLine');
            const btnDeleteObserversLine = $('#btnDeleteObserversLine');
            const btnDrawBeatersLine = $('#btnDrawBeatersLine');
            const btnDeleteBeatersLine = $('#btnDeleteBeatersLine');

            const drawHelp = $('.draw-help');

            let epMap = new EpMap({target});

            let locationsLayer = null;
            if(typeof window._locations != 'undefined') {
                let locations = JSON.parse(window._locations);

                if(/edit\/locations.*?\/(edit)/.test(window.location.href)) {
                    let match = window.location.href.match(/edit\/locations\/(.*?)\/(edit)/);
                    locations = locations.filter(location => parseInt(location.id) !== parseInt(match[1]));
                }

                // locations layer
                locationsLayer = new EpLayer(epMap.map);
                locationsLayer.setStyle(inventoryLocationStyle, farInventoryLocationStyle);
                locationsLayer.name = 'locations';
                locationsLayer.title = 'Obszary';

                epMap.changeStyleUnderZoom(locationsLayer)

                for(let location of locations) {
                    locationsLayer.addFeature(location.coordinates, {
                        fields: {
                            name: location.name
                        }
                    });
                }

                epMap.addCustomLayer(locationsLayer);
            }


            let boundariesCoordinates = [];

            epMap.addBoundariesLayer();
            if (typeof window._boundaries != 'undefined') {
                epMap.boundaries.addFeature(window._boundaries);

                for (let coords of epMap.boundaries.getSource().getFeatures()[0].getGeometry().getCoordinates()[0]) {
                    boundariesCoordinates = [...boundariesCoordinates, toLonLat(coords)]
                }
            }

            const boundariesGeoJson =
                {
                    type: "Feature",
                    properties: {},
                    geometry: {
                        type: "Polygon",
                        coordinates: [
                            boundariesCoordinates
                        ]
                    }
                };

            let bufferedBoundariesPolygon = turf.toMercator(buffer(boundariesGeoJson, 2, 'metres'));

            epMap.addSectorsLayer();
            if (typeof window._sectors != 'undefined') {
                epMap.sectors.addSectorsFromObject(JSON.parse(window._sectors));
            }

            let locationLayer = new EpLayer(epMap);
            locationLayer.setStyle(inventoryLocationStyle)
            locationLayer.name = 'location';
            locationLayer.title = 'Obszar';

            let locationFeature;
            let observersLineFeature;
            let beatersLineFeature;

            let interaction = null;
            let sectorSnapInteraction = null;
            let boundariesSnapInteraction = null;
            let locationSnapInteraction = null;
            let locationsSnapInteraction = null;

            epMap.addCustomLayer(locationLayer);

            const updateArea = () => {
                if (parseInt(areaChangedManually.val()) === 0 || areaInput.val().length === 0) {
                    areaInput.val((getArea(locationFeature.getGeometry()) / 10000).toFixed(2))
                }
            }

            const toggleInteraction = (toggleMode) => {
                btnDrawLocation.removeClass('btn-warning')
                btnDrawObserversLine.removeClass('btn-warning')
                btnDrawBeatersLine.removeClass('btn-warning')

                drawHelp.text('');

                if(interaction) {
                    epMap.getOlMap().removeInteraction(interaction);
                    interaction = null;
                }

                if (sectorSnapInteraction) {
                    epMap.getOlMap().removeInteraction(sectorSnapInteraction);
                    sectorSnapInteraction = null;
                }

                if (boundariesSnapInteraction) {
                    epMap.getOlMap().removeInteraction(boundariesSnapInteraction)
                    boundariesSnapInteraction = null;
                }

                if (locationSnapInteraction) {
                    epMap.getOlMap().removeInteraction(locationSnapInteraction)
                    locationSnapInteraction = null;
                }

                if (locationsSnapInteraction) {
                    epMap.getOlMap().removeInteraction(locationsSnapInteraction)
                    locationsSnapInteraction = null;
                }

                let oldMode = mode;
                mode = 0;

                switch(toggleMode) {
                    case 1:
                        if(oldMode !== 1) {
                            btnDrawLocation.addClass('btn-warning')
                            mode = 1;

                            if(locationFeature) {
                                interaction = locationLayer.addEdit({
                                    style: drawInventoryLocationStyle,
                                    features: new Collection([locationFeature]),
                                    end: function (e) {
                                        let feature = e.features.item(0);

                                        if (!turf.booleanWithin(turf.polygon(feature.getGeometry().getCoordinates()), bufferedBoundariesPolygon)) {
                                            if(locationFeature) {
                                                let points = coordinatesInput.val().split(" ");
                                                let coordinatesArray = [points.filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")))];
                                                locationFeature.getGeometry().setCoordinates(coordinatesArray);
                                            }
                                            return;
                                        }

                                        let coordinates = feature.getGeometry().getCoordinates().map(arr => arr.map(el => toLonLat(el).join(',')).join(' '))[0];
                                        coordinatesInput.val(coordinates).change();

                                        updateArea();
                                    }
                                })
                            } else {
                                interaction = locationLayer.addDraw({
                                    style: drawInventoryLocationStyle,
                                    condition: (e) => {
                                        let features = epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                                            layerFilter: function (layer) {
                                                return layer === epMap.boundaries.getLayer();
                                            }
                                        });
                                        return features.length > 0;
                                    },
                                    end: function (e) {
                                        locationFeature = e.feature;

                                        let coordinates = e.feature.getGeometry().getCoordinates().map(arr => arr.map(el => toLonLat(el).join(',')).join(' '))[0];
                                        e.feature.set('type', 'location');
                                        e.feature.set('edited', 'true');

                                        coordinatesInput.val(coordinates).change();

                                        toggleInteraction(1);
                                    }
                                });
                            }
                        }

                        break;
                    case 2:
                        if(oldMode !== 2) {
                            btnDrawObserversLine.addClass('btn-warning')
                            mode = 2;

                            if(observersLineFeature) {
                                interaction = locationLayer.addEdit({
                                    style: drawInventoryLocationStyle,
                                    features: new Collection([observersLineFeature]),
                                    end: function (e) {
                                        let feature = e.features.item(0);

                                        if (!turf.booleanWithin(turf.lineString(feature.getGeometry().getCoordinates()), bufferedBoundariesPolygon)) {
                                            if(observersLineFeature) {
                                                let points = observersLineCoordinatesInput.val().split(" ");
                                                let coordinatesArray = points.filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")));
                                                observersLineFeature.getGeometry().setCoordinates(coordinatesArray);
                                            }
                                            return;
                                        }

                                        let coordinates = e.features.item(0).getGeometry().getCoordinates().map(el => toLonLat(el).join(',')).join(' ');
                                        observersLineCoordinatesInput.val(coordinates).change();
                                    }
                                })
                            } else {
                                drawHelp.text('Aby zakończyć rysowanie linii, kliknij drugi raz w miejsce ostatniego punktu');

                                interaction = locationLayer.addDraw({
                                    style: drawInventoryLocationStyle,
                                    type: 'LineString',
                                    condition: (e) => {
                                        let features = epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                                            layerFilter: function (layer) {
                                                return layer === epMap.boundaries.getLayer();
                                            }
                                        });
                                        return features.length > 0;
                                    },
                                    end: function (e) {
                                        observersLineFeature = e.feature;

                                        let coordinates = e.feature.getGeometry().getCoordinates().map(el => toLonLat(el).join(',')).join(' ');
                                        observersLineCoordinatesInput.val(coordinates).change();

                                        e.feature.setStyle(inventoryLocationObserversLineStyle)

                                        toggleInteraction(2);
                                    }
                                });
                            }
                        }

                        break;
                    case 3:
                        if(oldMode !== 3) {
                            btnDrawBeatersLine.addClass('btn-warning')
                            mode = 3;

                            if(beatersLineFeature) {
                                interaction = locationLayer.addEdit({
                                    style: drawInventoryLocationStyle,
                                    features: new Collection([beatersLineFeature]),
                                    end: function (e) {
                                        let feature = e.features.item(0);

                                        if (!turf.booleanWithin(turf.lineString(feature.getGeometry().getCoordinates()), bufferedBoundariesPolygon)) {
                                            if(beatersLineFeature) {
                                                let points = beatersLineCoordinatesInput.val().split(" ");
                                                let coordinatesArray = points.filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")));
                                                beatersLineFeature.getGeometry().setCoordinates(coordinatesArray);
                                            }
                                            return;
                                        }

                                        let coordinates = e.features.item(0).getGeometry().getCoordinates().map(el => toLonLat(el).join(',')).join(' ');
                                        beatersLineCoordinatesInput.val(coordinates).change();
                                    }
                                })
                            } else {
                                drawHelp.text('Aby zakończyć rysowanie linii, kliknij drugi raz w miejsce ostatniego punktu');

                                interaction = locationLayer.addDraw({
                                    style: drawInventoryLocationStyle,
                                    type: 'LineString',
                                    condition: (e) => {
                                        let features = epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                                            layerFilter: function (layer) {
                                                return layer === epMap.boundaries.getLayer();
                                            }
                                        });
                                        return features.length > 0;
                                    },
                                    end: function (e) {
                                        beatersLineFeature = e.feature;

                                        let coordinates = e.feature.getGeometry().getCoordinates().map(el => toLonLat(el).join(',')).join(' ');
                                        beatersLineCoordinatesInput.val(coordinates).change();

                                        e.feature.setStyle(inventoryLocationBeatersLineStyle)

                                        toggleInteraction(3);
                                    }
                                });
                            }
                        }

                        break;
                }

                if(interaction) {
                    epMap.getOlMap().addInteraction(interaction);
                    sectorSnapInteraction = epMap.addSnap(epMap.sectors.getSource())
                    boundariesSnapInteraction = epMap.addSnap(epMap.boundaries.getSource())
                    locationSnapInteraction = epMap.addSnap(locationLayer.getSource())

                    if(locationsLayer) {
                        locationsSnapInteraction = epMap.addSnap(locationsLayer.getSource())
                    }

                    epMap.getOlMap().addInteraction(sectorSnapInteraction);
                    epMap.getOlMap().addInteraction(boundariesSnapInteraction);
                    epMap.getOlMap().addInteraction(locationSnapInteraction);

                    if(locationsSnapInteraction) {
                        epMap.getOlMap().addInteraction(locationsSnapInteraction);
                    }
                }
            }

            const updateObserversMarkers = () => {
                let features = locationLayer.getSource().getFeatures().filter(feature => feature.get('type') === 'observer');
                for (let feature of features) {
                    locationLayer.getSource().removeFeature(feature);
                }

                let observersCount = $('input[name="observers_count"]').val();
                if(!observersCount || observersCount.length === 0 || observersLineCoordinatesInput.val().length === 0 || parseInt(observersCount) <= 1) {
                    return;
                }

                let points = observersLineCoordinatesInput.val().split(" ");
                let coordinatesArray = points.map(coord => coord.split(",").map(a => parseFloat(a)));
                let line = turf.lineString(coordinatesArray);

                let length = turf.length(line, {units: 'meters'})
                let chunkLength = length/(parseInt(observersCount)-1);

                let chunks = turf.lineChunk(line, chunkLength, {units: 'meters'})

                features = [];
                let i = 1;
                for(let line of chunks.features) {
                    let feature = new Feature({
                        geometry: new Point(fromLonLat([line.geometry.coordinates[0][0], line.geometry.coordinates[0][1]])),
                    })
                    feature.setStyle(inventoryLocationObserversLineStyle)
                    feature.set('type', 'observer')
                    feature.set('name', String(i));
                    features = [...features, feature]

                    i++
                }

                let feature = new Feature({
                    geometry: new Point(fromLonLat([line.geometry.coordinates[line.geometry.coordinates.length-1][0], line.geometry.coordinates[line.geometry.coordinates.length-1][1]])),
                })
                feature.setStyle(inventoryLocationObserversLineStyle)
                feature.set('type', 'observer')
                feature.set('name', String(i));
                features = [...features, feature]

                let coordinates = '';
                for(let feature of features) {
                    coordinates += ' ' + toLonLat(feature.getGeometry().getCoordinates()).join(',');
                }
                $('input[name="observers_spots"]').val(coordinates);

                locationLayer.getSource().addFeatures(features);

                $('.observers_distance').text((length/(parseInt(observersCount)-1)).toFixed(2) + 'm');
            }

            const updateBeatersMarkers = () => {
                let features = locationLayer.getSource().getFeatures().filter(feature => feature.get('type') === 'beater');
                for (let feature of features) {
                    locationLayer.getSource().removeFeature(feature);
                }

                let beatersCount = $('input[name="beaters_count"]').val();
                if(!beatersCount || beatersCount.length === 0 || beatersLineCoordinatesInput.val().length === 0 || parseInt(beatersCount) <= 1) {
                    return;
                }

                let points = beatersLineCoordinatesInput.val().split(" ");
                let coordinatesArray = points.map(coord => coord.split(",").map(a => parseFloat(a)));
                let line = turf.lineString(coordinatesArray);

                let length = turf.length(line, {units: 'meters'})
                let chunkLength = length/(parseInt(beatersCount)-1);

                let chunks = turf.lineChunk(line, chunkLength, {units: 'meters'})

                features = [];
                let i = 1;
                for(let line of chunks.features) {
                    let feature = new Feature({
                        geometry: new Point(fromLonLat([line.geometry.coordinates[0][0], line.geometry.coordinates[0][1]])),
                    })
                    feature.setStyle(inventoryLocationBeatersLineStyle)
                    feature.set('type', 'beater')
                    feature.set('name', String(i));
                    features = [...features, feature]

                    i++;
                }

                let feature = new Feature({
                    geometry: new Point(fromLonLat([line.geometry.coordinates[line.geometry.coordinates.length-1][0], line.geometry.coordinates[line.geometry.coordinates.length-1][1]])),
                })
                feature.setStyle(inventoryLocationBeatersLineStyle)
                feature.set('type', 'beater')
                feature.set('name', String(i));
                features = [...features, feature]

                let coordinates = '';
                for(let feature of features) {
                    coordinates += ' ' + toLonLat(feature.getGeometry().getCoordinates()).join(',');
                }
                $('input[name="beaters_spots"]').val(coordinates);

                locationLayer.getSource().addFeatures(features);

                $('.beaters_distance').text((length/(parseInt(beatersCount)-1)).toFixed(2) + 'm');
            }

            coordinatesInput.change(function () {
                let value = $(this).val();

                if (value.length > 0) {
                    btnDrawLocation.text('Edytuj obszar');

                    if(!locationFeature) {
                        locationFeature = locationLayer.addFeature(value, {fields: {type: 'location', edited: true}});
                    }

                    updateArea();

                    btnDeleteLocation.attr('disabled', false);
                } else {
                    btnDrawLocation.text('Rysuj obszar');

                    btnDeleteLocation.attr('disabled', true);
                }
            }).change()

            observersLineCoordinatesInput.change(function () {
                let value = $(this).val();

                updateObserversMarkers();

                if (value.length > 0) {
                    btnDrawObserversLine.text('Edytuj linię obserwacji');

                    if(!observersLineFeature) {
                        observersLineFeature = locationLayer.addFeature(value, {type: 'LineString', fields: {type: 'observers_line'}});
                        observersLineFeature.setStyle(inventoryLocationObserversLineStyle)
                    }

                    btnDeleteObserversLine.attr('disabled', false);
                } else {
                    btnDrawObserversLine.text('Rysuj linię obserwacji');

                    btnDeleteObserversLine.attr('disabled', true);
                }

                if(observersLineFeature) {
                    let length = getLength(observersLineFeature.getGeometry()).toFixed(2);
                    $('.observers_line_length').text(length + 'm')
                }
            }).change();

            beatersLineCoordinatesInput.change(function () {
                let value = $(this).val();

                updateBeatersMarkers();

                if (value.length > 0) {
                    btnDrawBeatersLine.text('Edytuj linię naganki');

                    if(!beatersLineFeature) {
                        beatersLineFeature = locationLayer.addFeature(value, {type: 'LineString', fields: {type: 'beaters_line'}});
                        beatersLineFeature.setStyle(inventoryLocationBeatersLineStyle)
                    }

                    btnDeleteBeatersLine.attr('disabled', false);
                } else {
                    btnDrawBeatersLine.text('Rysuj linię naganki');

                    btnDeleteBeatersLine.attr('disabled', true);
                }

                if(beatersLineFeature) {
                    let length = getLength(beatersLineFeature.getGeometry()).toFixed(2);
                    $('.beaters_line_length').text(length + 'm')
                }
            }).change()

            btnDrawLocation.click(function() {
                toggleInteraction(1);
            })

            btnDeleteLocation.click(async function() {
                if(await confirmModal('Czy na pewno chcesz usunąć narysowany obszar?', {color: 'danger'})) {
                    locationLayer.getSource().removeFeature(locationFeature);
                    locationFeature = null;

                    coordinatesInput.val('').change();
                }
            })

            btnDrawObserversLine.click(function() {
                toggleInteraction(2);
            })

            btnDeleteObserversLine.click(async function() {
                if(await confirmModal('Czy na pewno chcesz usunąć narysowaną linię obserwacji?', {color: 'danger'})) {
                    locationLayer.getSource().removeFeature(observersLineFeature);
                    observersLineFeature = null;

                    observersLineCoordinatesInput.val('').change();
                }
            })

            btnDrawBeatersLine.click(function() {
                toggleInteraction(3);
            })

            btnDeleteBeatersLine.click(async function() {
                if(await confirmModal('Czy na pewno chcesz usunąć narysowaną linię naganki?', {color: 'danger'})) {
                    locationLayer.getSource().removeFeature(beatersLineFeature);
                    beatersLineFeature = null;

                    beatersLineCoordinatesInput.val('').change();
                }
            })

            $('input[name="observers_count"]').change(function() {
                updateObserversMarkers();
            })

            $('input[name="beaters_count"]').change(function() {
                updateBeatersMarkers();
            })

            $('#btnGenerateBasedOnDistrict').click(async function() {
                if(!locationFeature) {
                    coordinatesInput.val(window._boundaries).change();

                    updateArea();
                    return;
                }

                let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz zmienić granicę obszaru?');
                if (!confirm) return;

                coordinatesInput.val(window._boundaries).change();

                let points = coordinatesInput.val().split(" ");
                let coordinatesArray = [points.filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")))];
                locationFeature.getGeometry().setCoordinates(coordinatesArray);

                updateArea();
            })
        }

        setupLocationInteractions();
    }

    /// Reports
    const correctTypeInputs = $('input[name="correct_type"]');
    const areaTypeInputs = $('input[name="area_type"]');

    if(correctTypeInputs.length > 0) {
        const handleCorrectTypeChange = (val) => {
            if (val === 1) {
                $('.correct-species-inputs input').attr('disabled', true);
                $('.correct-all-inputs input').attr('disabled', false);

                $('.correct-species-inputs label').css('opacity', '0.5');
                $('.correct-all-inputs label').css('opacity', '1');
            } else {
                $('.correct-species-inputs input').attr('disabled', false);
                $('.correct-all-inputs input').attr('disabled', true);

                $('.correct-species-inputs label').css('opacity', '1');
                $('.correct-all-inputs label').css('opacity', '0.5');
            }
        }
        handleCorrectTypeChange(parseInt(correctTypeInputs.val()));

        correctTypeInputs.change(function () {
            handleCorrectTypeChange(parseInt($(this).val()))
        })

        const handleAreaTypeChange = (val) => {
            if (val === 1) {
                $('.area-species-inputs input').attr('disabled', true);
                $('.area-all-inputs input').attr('disabled', false);

                $('.area-species-inputs label').css('opacity', '0.5');
                $('.area-all-inputs label').css('opacity', '1');
            } else {
                $('.area-species-inputs input').attr('disabled', false);
                $('.area-all-inputs input').attr('disabled', true);

                $('.area-species-inputs label').css('opacity', '1');
                $('.area-all-inputs label').css('opacity', '0.5');
            }
        }
        handleAreaTypeChange(parseInt(areaTypeInputs.val()));

        areaTypeInputs.change(function () {
            handleAreaTypeChange(parseInt($(this).val()))
        })

        $('input[name="is_insert_rdlp"]').change(function () {
            if ($(this).is(':checked')) {
                $('input[name="rdlp"]').attr('disabled', false);
            } else {
                $('input[name="rdlp"]').attr('disabled', true);
            }
        }).change();

        $('input[name="is_insert_observers_count"]').change(function () {
            $('.observes-count-inputs input').attr('disabled', !$(this).is(':checked'))
        }).change()

        let iframe = $('iframe');

        const setHeight = (iframe, spinner, counter = 0) => {
            let height = iframe.contentWindow.document.body.scrollHeight;

            if (counter > 50) {
                iframe.style.height = 'initial';
                spinner.destroy();
            }

            if (height === 0) {
                setTimeout(() => {
                    setHeight(iframe, spinner, counter++)
                }, 50)
            } else {
                iframe.style.height = height + 64 + 'px';
                spinner.destroy();
            }
        }

        const loadReportPreview = async () => {
            let form = new FormData($('#generateReport')[0]);
            let query = new URLSearchParams(form).toString();

            let spinner = new Spinner($(iframe).parent(), null, null, 'absolute');
            iframe.height(0);

            iframe[0].src = url(`app/inventories/${form.get('id')}/report?preview=true&${query}`);

            iframe.on('load', function () {
                setHeight(this, spinner);
                iframe.off('load');
            })
        }
        loadReportPreview();

        $("#btnGetPdf").click(async function() {
            let form = $('#generateReport');

            let spinner = new Spinner(null, 'Trwa generowanie raportu PDF...');

            try {
                let response = await axios.post(url(`app/inventories/${$(this).data('id')}/report/pdf`), new FormData(form[0]), {
                    responseType: 'blob'
                });

                if(response && response.status === 200) {
                    FileDownload(response.data, 'Raport.pdf');
                }
            } catch(err) {
                toastAlert('Nie udało się wygenerować PDF. Spróbuj ponownie później.', {type: 'danger'});
            }

            spinner.destroy();

            // let form = new FormData($('#generateReport')[0]);
            // const response = await axios.post(url(`app/inventories/${$(this).data('id')}/report/pdf`), form);
            //
            // console.log(response)
        })

        $("#btnGetDocx").click(async function() {
            let form = $('#generateReport');

            let spinner = new Spinner(null, 'Trwa generowanie raportu DOCX...');

            try {
                let response = await axios.post(url(`app/inventories/${$(this).data('id')}/report/docx`), new FormData(form[0]), {
                    responseType: 'blob'
                });

                if(response && response.status === 200) {
                    FileDownload(response.data, 'Raport.docx');
                }
            } catch(err) {
                toastAlert('Nie udało się wygenerować DOCX. Spróbuj ponownie później.', {type: 'danger'});
            }

            spinner.destroy();
        })

        $("#btnGetXlsx").click(async function() {
            let form = $('#generateReport');

            let spinner = new Spinner(null, 'Trwa generowanie raportu XLSX...');

            try {
                let response = await axios.post(url(`app/inventories/${$(this).data('id')}/report/xlsx`), new FormData(form[0]), {
                    responseType: 'blob'
                });

                if(response && response.status === 200) {
                    FileDownload(response.data, 'Raport.xlsx');
                }
            } catch(err) {
                toastAlert('Nie udało się wygenerować XLSX. Spróbuj ponownie później.', {type: 'danger'});
            }

            spinner.destroy();
        })

        $('#generateReport :input').change(_.debounce(function () {
            loadReportPreview()
        }, 1000))
    }
}
